export default __webpack_public_path__ + "static/INSTAR-HomeKit-HomeApp-ebf89ae30ae6973bc300092f056d5dc4.webp";